import { session } from '@/api/session'

export default {
  signIn (payload) {
    return session.post(`${process.env.VUE_APP_BACKEND_API_URL}accounts/login/`, payload)
  }
}
